module.exports = __webpack_public_path__ + "img/1531040535.d3dfdbe3.jpg";